import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/manual/log/page`
  return http.post(url, params)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取操作人列表
const getAuditUsers = () => {
  const url = '/api/v1/users/all'
  return http.post(url)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取备注模板列表
const getRemarkTemplate = () => {
  const url = '/market/manual/questionnaire/list'
  return http.post(url)
}
// 获取备注模板详情
const getRemarkTemplateAction = (id) => {
  const url = `/market/manual/questionnaire/detail/${id}`
  return http.post(url)
}
// 获取历史问卷列表
const getHistoryAction = (params) => {
  const url = `/market/manual/log/history`
  return http.post(url, params)
}
// 获取详情
const getAction = (params) => {
  const url = `/market/manual/log/detail`
  return http.post(url, params)
}
// 新建
const addAction = (params) => {
  const url = `/market/manual/log/save`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/group/delete/${id}`
  return http.post(url)
}
// 获取cti token
const getTokenLogin = (params) => {
  const url = `/market/manual/log/token/login`
  return http.post(url,params)
}
// 释放席位
const getTokenLogout = (params) => {
  const url = `/market/manual/log/token/logout`
  return http.post(url,params)
}

export default {
  searchAction,
  getGroup,
  getAuditUsers,
  getStatus,
  getRemarkTemplate,
  getRemarkTemplateAction,
  getHistoryAction,
  getAction,
  addAction,
  deleteAction,
  getTokenLogin,
  getTokenLogout
}
